import {ReactElement} from 'react'
import {Trans} from 'react-i18next'

import messages from '../assets/messages'
import {useVideoVerificationContext} from './VideoVerificationProvider'
import {formatHeldAmount} from './utils'
import {videoVerificationStatuses} from '@bdswiss/common-enums'
import './video-verification.css'

type VideoVerificationBannerProps = {
  /** Banner I: the check applies to the client and no withdrawal waits. Banner H is always shown. */
  showEarly?: boolean
}

/**
 * Banner H while a withdrawal waits for the video verification, and banner I (verify early) otherwise.
 * It shows no limit and no total: the server sends only the flag, the status and the held withdrawals.
 */
function VideoVerificationBanner({showEarly = false}: VideoVerificationBannerProps): ReactElement | null {
  const {available, status, hasHeldWithdrawals, heldWithdrawals, openVideoVerification} = useVideoVerificationContext()

  if (hasHeldWithdrawals) {
    return (
      <div className="vv-banner vv-banner--waiting" data-testid="vv-banner-waiting">
        <span>
          <Trans
            {...messages.videoVerificationBannerWaiting}
            values={{amount: formatHeldAmount(heldWithdrawals)}}
          />
        </span>
        <button type="button" className="vv-link" onClick={() => openVideoVerification()}>
          <Trans {...messages.videoVerificationBannerContinue} />
        </button>
      </div>
    )
  }

  // The gate is the server field `available` (PT-7834), not the status: while the check is off no client sees banner I.
  if (showEarly && available && status !== videoVerificationStatuses.verified.key) {
    return (
      <div className="vv-banner vv-banner--early" data-testid="vv-banner-early">
        <span>
          <Trans {...messages.videoVerificationBannerEarly} />
        </span>
        <button type="button" className="vv-link" onClick={() => openVideoVerification()}>
          <Trans {...messages.videoVerificationBannerVerifyNow} />
        </button>
      </div>
    )
  }

  return null
}

export {VideoVerificationBanner}
